import { DEVICE_MAKES } from "../../../../../common/data/deviceMakes";

export const useGetDevicesMakesCached = () => ({
  data: { getDevicesMakes: { items: DEVICE_MAKES, nextToken: null } },
  loading: false,
});
